import React from 'react'
import css from './style.scss'
import downloadStories from 'shared/download_stories'
import store from 'utils/store'
import analytics from 'utils/analytics'

const status={
  "waiting":"Waiting...",
  "csv":"Preparing CSV file...",
  "downloading":"Downloading media...",
  "finishing":"Finishing...",
  "done":"Done!",
}

class MiniExport extends React.Component{
  constructor(props){
    super(props)
    this.state={
      status:"waiting",
      percentage:0
    }
  }
  componentDidMount(){
    downloadStories(this.props.stories, this.props.filename, this.handleProgress)
  }
  handleProgress=(state)=>{
    this.setState(state)
    if(state.status==="done"){
      setTimeout(()=>{
        analytics.track("export_data")
        store.dispatch({type:"FINISH_EXPORT", payload:this.props.id})
      },5000)
    }
  }
  render(){
    return (
      <div className={css.miniExport}>
        <div className={css.current_status}>
          <div className={css.title}>Export Stories</div>
          <div className={css.status}>
            {status[this.state.status]}
          </div>
        </div>
        <div className={css.circle}>
          {this.state.percentage}%
        </div>
      </div>
    );
  }
}

export default MiniExport;



// WEBPACK FOOTER //
// ./src/components/account_page/download/mini.js